import {QUESTION_TYPES} from './questionTypeConstants';
import {
    FiType,
    FiAlignLeft,
    FiCircle,
    FiCheckSquare,
    FiChevronDown,
    FiStar,
    FiGitMerge,
    FiUpload,
    FiCalendar,
    FiClock, FiPhone, FiMail, FiHash, FiThumbsUp
} from 'react-icons/fi';

// Импорты всех компонентов-редакторов
import TextSpecificEditor from './QuestionTypeSpecificEditors/TextSpecificEditor';
import ParagraphSpecificEditor from './QuestionTypeSpecificEditors/ParagraphSpecificEditor';
import ChoiceOptionsEditor from './QuestionTypeSpecificEditors/ChoiceOptionsEditor/ChoiceOptionsEditor';
import RatingEditor from './QuestionTypeSpecificEditors/RatingEditor/RatingEditor';
import DateSpecificEditor from './QuestionTypeSpecificEditors/DateSpecificEditor';
import TimeSpecificEditor from './QuestionTypeSpecificEditors/TimeSpecificEditor';
import LinearScaleEditor from "./QuestionTypeSpecificEditors/LinearScaleEditor/LinearScaleEditor";

// Заглушка для типов, у которых пока нет своего редактора настроек
const PlaceholderEditor = () => null;

export const QUESTION_CONFIG = [
    {
        type: QUESTION_TYPES.TEXT,
        labelId: "questionType.text",
        icon: FiType,
        needsOptions: false,
        defaultTextId: "question.defaultText.untitled",
        EditorComponent: TextSpecificEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.PARAGRAPH,
        labelId: "questionType.paragraph",
        icon: FiAlignLeft,
        needsOptions: false,
        defaultTextId: "question.defaultText.untitled",
        EditorComponent: ParagraphSpecificEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.RADIO,
        labelId: "questionType.radio",
        icon: FiCircle,
        needsOptions: true,
        defaultTextId: "question.defaultText.choice",
        defaultOptions: [{textId: 'question.defaultOptionText', values: {number: 1}}],
        EditorComponent: ChoiceOptionsEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.CHECKBOX,
        labelId: "questionType.checkbox",
        icon: FiCheckSquare,
        needsOptions: true,
        defaultTextId: "question.defaultText.choice",
        defaultOptions: [{textId: 'question.defaultOptionText', values: {number: 1}}],
        EditorComponent: ChoiceOptionsEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.DROPDOWN,
        labelId: "questionType.dropdown",
        icon: FiChevronDown,
        needsOptions: true,
        defaultTextId: "question.defaultText.choice",
        defaultOptions: [{textId: 'question.defaultOptionText', values: {number: 1}}],
        EditorComponent: ChoiceOptionsEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.RATING,
        labelId: "questionType.rating",
        icon: FiStar,
        needsOptions: true,
        defaultTextId: "question.defaultText.rate",
        defaultOptions: Array.from({length: 3}, () => ({text: ''})),
        config: {icon: 'star'},
        EditorComponent: RatingEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.LINEAR_SCALE,
        labelId: "questionType.linear_scale",
        icon: FiGitMerge,
        needsOptions: false, // <-- ВАЖНО: опции нам не нужны, используем config
        defaultTextId: "question.defaultText.scale",
        // Задаем конфигурацию по умолчанию
        config: {
            min: 1,
            max: 5,
            min_label: '',
            max_label: ''
        },
        EditorComponent: LinearScaleEditor, // <-- Указываем новый редактор
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.FILE,
        labelId: "questionType.file",
        icon: FiUpload,
        needsOptions: false,
        defaultTextId: "question.defaultText.upload",
        EditorComponent: PlaceholderEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.DATE,
        labelId: "questionType.date",
        icon: FiCalendar,
        needsOptions: false,
        defaultTextId: "question.defaultText.date",
        EditorComponent: DateSpecificEditor,
        default_is_required: false,
    },
    {
        type: QUESTION_TYPES.TIME,
        labelId: "questionType.time",
        icon: FiClock,
        needsOptions: false,
        defaultTextId: "question.defaultText.time",
        EditorComponent: TimeSpecificEditor,
        default_is_required: false,
    },
    {
        type: 'phone', // Добавьте 'phone' в QUESTION_TYPES в questionTypeConstants.js
        labelId: "questionType.phone",
        icon: FiPhone,
        needsOptions: false,
        defaultTextId: "question.defaultText.phone",
        EditorComponent: () => null, // Для поля "Телефон" пока нет настроек
        default_is_required: false,
    },
    {
        type: 'email', // Добавьте 'email' в QUESTION_TYPES в questionTypeConstants.js
        labelId: "questionType.email",
        icon: FiMail,
        needsOptions: false,
        defaultTextId: "question.defaultText.email",
        EditorComponent: () => null, // Для поля "Email" пока нет специальных настроек
        default_is_required: false,
    },
    {
        type: 'integer', // Добавьте 'integer' в QUESTION_TYPES
        labelId: "questionType.integer",
        icon: FiHash,
        needsOptions: false,
        defaultTextId: "question.defaultText.integer",
        EditorComponent: () => null,
        default_is_required: false,
    },
    {
        type: 'decimal', // Добавьте 'decimal' в QUESTION_TYPES
        labelId: "questionType.decimal",
        icon: FiHash, // Можно использовать ту же иконку
        needsOptions: false,
        defaultTextId: "question.defaultText.decimal",
        EditorComponent: () => null,
        default_is_required: false,
    },
    {
        type: 'yes_no', // Добавьте 'yes_no' в QUESTION_TYPES
        labelId: "questionType.yes_no",
        icon: FiThumbsUp,
        needsOptions: false, // <-- ВАЖНО: опции не нужны, они создаются автоматически
        defaultTextId: "question.defaultText.yes_no",
        EditorComponent: () => null, // Для этого типа нет специальных настроек
        default_is_required: false,
    },
    {
        type: 'text_block', // Добавьте 'text_block' в QUESTION_TYPES
        labelId: "questionType.text_block",
        icon: FiType,
        needsOptions: false,
        defaultTextId: "question.defaultText.text_block",
        EditorComponent: () => null,
        default_is_required: false,
    },
];
